import { useTranslation } from "react-i18next"
import { ChartColumnBig } from "lucide-react"
import { useFeatureFlagEnabled } from "posthog-js/react"
import BaseSidebarButton from "./BaseSidebarButton"
import { TAB_TYPES } from "@/reducers/tabsSlice"
import { ChartColumnBigIconActive } from "@/components/icons/ChartColumnBigIcon"

const ReportSidebarButton = ({ className }: { className?: string }) => {
  const { t } = useTranslation()
  const areReportsEnabled = Boolean(useFeatureFlagEnabled("reports"))

  if (!areReportsEnabled) return null

  return (
    <BaseSidebarButton
      tabName={TAB_TYPES.REPORTS}
      icon={ChartColumnBig}
      activeIcon={ChartColumnBigIconActive}
      tooltipText={t("app.sidebar.reports")}
      className={className}
    />
  )
}

export default ReportSidebarButton
